import { useAppSettingStore } from '@/client/store/app-store';
import { api } from '@/client/utils/api';
import { useMarkets } from '@/libs/react-sdk/api/use-markets';
import type { MarketsParams } from '@/libs/sdk/api';

// Fixed page-1 / pageSize-10 params for the home preview feed. Exported so
// both consumers (and tests) build the searchParams object the exact same
// way -- that's what makes their react-query keys match.
export const buildHomeMarketsPreviewParams = (baseTokenAddress: string): MarketsParams => ({
  page: 1,
  pageSize: 10,
  baseTokenAddress,
});

export type UseHomeMarketsPreviewOptions = {
  enabled?: boolean;
};

// Canonical ticker preview list (page 1 / 10 items / current lens). Kept as
// a hook so any future consumer of the same list lands on the same query
// key instead of hand-building its own params shape and firing a duplicate
// request. (Search recommendations use useTrendingMarkets -- a volume-sorted
// list shared with the home trending rail -- not this hook.)
export const useHomeMarketsPreview = (options?: UseHomeMarketsPreviewOptions) => {
  const lensTokenAddress = useAppSettingStore(state => state.baseToken.address);
  return useMarkets(api, buildHomeMarketsPreviewParams(lensTokenAddress), { enabled: options?.enabled });
};
